import ImageViewer from './image-viewer';

export default ImageViewer;



// WEBPACK FOOTER //
// ./src/components/image-viewer/index.js